import { lifetimeButton } from '../button/type'

const noButtonStatus = [
  'Out of Stock',
  'Cancelled',
]

const useManageLifetimeButton = ({
  showReturn,
  itemDetails,
}) => {
  const { returnRequest, itemStatus } = { ...itemDetails }
  const { credit_status_code: creditStatusCode } = { ...returnRequest }

  if (!showReturn && noButtonStatus.indexOf(itemStatus) > -1) return lifetimeButton.empty
  if (!showReturn && creditStatusCode === 3015) return lifetimeButton.claim
  if (!showReturn && creditStatusCode !== 3015) return lifetimeButton.selectItemDisabled
  if (itemDetails?.isLifetimeReplacement === '1') return lifetimeButton.selectItem

  return lifetimeButton.ineligible
}

export default useManageLifetimeButton
